import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import * as lookup from "../../../../static/lookup.json"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import { SectionContext } from "../../context/sectionContext"
import { JourneyContext } from "../../context/journeyContext"
import { ConditionContext } from "../../context/conditionContext"
import { PageContext } from "../../context/pageContext"
import { ErrorContext } from "../../context/errorContext"
import {
  generateBI,
  fetchAllJourneyData,
  pdfDownload,
  uploadDocument,
  saveApplication,
  fetchApplicationDetails,
  sendEmailBI,
  s3uploadPdfBI,
  whatsAppOptin,
  getTOFpaymentReceipt,
  saveTransactionDetails,
  updateUserTrackerDetails,
  getConfigurationsByType
} from "../../../services/apiservice"
import {
  getDateInFormat,
  getStateFromCode,
  getAge,
  findCurrentJourneyCode,
  getValueFromLookup,
  findRiderSA,
  findRiderSAPercent,
  getSourceFromChannel,
  transformReceiptToTransaction
} from "../../services/helperFunctions"
import {
  errorToastr,
  successToastr,
  clearToastr,
} from "../../../services/error-handler"
import { wordCapital, lineCapital, applyComma, calculateAge } from '../../../shared/functions'
const moment = require('moment')
// import * as lookup from "../../../../static/lookup.json"
export default function BIGuaranteedFuture(props) {
  let [isactive, setIsActive] = useState(true)
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [errorState, setErrorState] = useContext(ErrorContext);
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)

  const [allJourneyData, setAllJourneyData] = useState()
  const [biApiData, setBiApiData] = useState()
  const [payNowOrLater, setPayNowOrLater] = useState("later")
  const [pdfData, setPdfData] = useState("")
  const [agreeToDeclaration, setAgreeToDeclaration] = useState(true)
  const [proceedWithOption, setProceedWithOption] = useState()
  const [location, setLocation] = useState()
  const [isChecked, setIsChecked] = useState(true)
  const [skipPayment, setSkipPayment] = useState(false)
  const [isPayBasba, setIsPayBasba] = useState(false)
  const [gstRate, setGstRate] = useState(null);
  console.log(allJourneyData?.productDetails?.planOption)

  //container
  const RadioContainer = styled.div`
    width: 100%;
    display: block;
    flex-direction: column;
    margin: 15px 0;
    position: relative;
    box-sizing: border-box;
    font-size: 15px;
    color: #505050;
    float: left;

    & > label {
      margin-left: 8px;
      margin-bottom: 5px;
      color: #505050;
      font-size: 16px;
      background-color: #fff;
      padding: 2px 5px;
      z-index: 999;
      position: relative;
      display: inline-block;
      cursor: default;
      max-width: 100%;
      & > .radio-label {
        text-align: center;
      }
    }

    .card {
      width: 100%;
      border-radius: 1rem;
      padding: 1rem 0;
      border-radius: 15px;
      background-color: #fff;
      position: relative;
      margin: 0px;
      margin-bottom: 0px;
      cursor: pointer;
      height: 9rem;
      margin-top: 0px;
      box-shadow: 0px 0px 20px #ccc;
      transition: all 200ms;

      .amount {
        color: black;
        margin-bottom: 2rem;
        margin-left: 6.5rem;
        border-left: 1px solid #ccc;
        padding-left: 1.5rem;
        height: 3rem;
        font-size: 21px;
      }
      .desc {
        padding: 0.8rem;
        background: #ededed;
        color: black;
        text-align: center;
        padding-right: 34px;
      }
    }

    /*Check tick start  */
    .checked {
      background: #ededed;
      color: #ededed;
      position: absolute;
      left: 2rem;
      top: 1rem;
      height: 2.5rem;
      width: 2.5rem;
      border-radius: 50%;
      padding: 8px;
      & > * {
        font-size: 1.2rem;
      }
    }

    input:checked ~ .card .checked {
      background: #fff;
      color: ${props =>
        props.channel === "A"
          ? "#3e505d"
          : props.channel === "B"
          ? "#a20a3a"
          : props.channel === "C"
          ? "#0ab0ef"
          : "#eb7f25"};
      color: var(--lumiq-card-bg);
    }
    /*Check tick end */

    .icon-container {
      font-size: 3rem;
      padding: 1rem;
      span {
        border-radius: 50%;
        padding: 1rem;

        background: #3e505d;
        .hero-icon {
          padding-top: 8px;
          color: #fff;
        }
      }
    }

    input:checked ~ .card {
      background-color: ${props =>
        props.channel === "A"
          ? "#3e505d"
          : props.channel === "B"
          ? "#a20a3a"
          : props.channel === "C"
          ? "#0ab0ef"
          : "#eb7f25"};
      background-color: var(--lumiq-card-bg);
      color: #fff;
      .icon-container-1 {
        span {
          background: #fff;
          .hero-icon {
            color: #3e505d;
          }
        }
      }

      .amount {
        color: white;
        margin-bottom: 2rem;
        margin-left: 6.5rem;
        border-left: 1px solid #ccc;
        padding-left: 1.5rem;
        height: 3rem;
        font-size: 21px;
      }
      .desc {
        padding: 0.8rem;
        background: #ffffff;
        color:black
        text-align: center;
        padding-right: 34px;
      }
    }

    input:not(:checked) ~ .card {
      /* opacity: 0.5; */
      .amount {
        color: #818181;
      }

      .desc {
        color: #3e505d;
      }
    }
  `
   //Helper Functions
   async function downloadLinkOfPdf(Base64Pdf) {
    // if(!location){
    //   const result = await s3uploadPdfBI({applicationNumber: journeyState.applicationNo,
    //     Base64Pdf: Base64Pdf,
    //   })
    //   setLocation(result.data.location)
    //   window.open(result.data.location,"_self");
    // }else{
    //   window.open(location,"_self");
    // }
    const fileName = `${lookup?.pdfProdutPlanName[journeyState?.journeyIdFromStrapi] ?? ""}_${journeyState.applicationNo}.pdf`
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      var byteCharacters = atob(Base64Pdf)
      var byteNumbers = new Array(byteCharacters.length)
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      var byteArray = new Uint8Array(byteNumbers)
      var blob = new Blob([byteArray], { type: "application/pdf" })
      window.navigator.msSaveOrOpenBlob(blob, fileName)
      return
    }
    // For Other Browsers
    const linkSource = "data:application/pdf;base64," + Base64Pdf
    const link = document.createElement("a")
    link.href = linkSource
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    link.remove()

    window.addEventListener(
      "focus",
      function () {
        URL.revokeObjectURL(link.href)
      },
      { once: true }
    )
  }

  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };

  const downloadPdf = async () => {
    let sendEmailPdfData = pdfData
    if (!sendEmailPdfData) {
      if (!biApiData) {
        return
      } else {
        let pdfResult = await pdfDownload({
          applicationNumber: journeyState.applicationNo,
          TID: biApiData?.TransactionId || "",
        })
        setPdfData(pdfResult.data.Base64Pdf)
        sendEmailPdfData = pdfResult.data.Base64Pdf
      }
    }
    downloadLinkOfPdf(sendEmailPdfData)
  }

  const printPdf = async () => {
    if (pdfData) {
      printPdf1(pdfData)
    } else {
      let pdfResult = await pdfDownload({
        applicationNumber: journeyState.applicationNo,
        TID: biApiData?.TransactionId || "",
      })
      setPdfData(pdfResult.data.Base64Pdf)
      printPdf1(pdfResult?.data?.Base64Pdf)
    }

    function printPdf1(base64Data) {
      const contentType = "application/pdf";
      const blob = b64toBlob(base64Data, contentType);
      const blobUrl = URL.createObjectURL(blob);
    
      // Open PDF in a new tab
      const newTab = window.open(blobUrl, "_blank");
    
      // Optional: attempt to trigger print (may be blocked by some browsers)
      if (newTab) {
        newTab.onload = () => {
          newTab.print();
        };
      } else {
        alert("Popup blocked. Please allow popups for this site to view and print the PDF.");
      }
    }
    
    function b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || ""
      sliceSize = sliceSize || 512

      var byteCharacters = atob(b64Data)
      var byteArrays = []

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize)

        var byteNumbers = new Array(slice.length)
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        var byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      var blob = new Blob(byteArrays, { type: contentType })
      return blob
    }
  }

  const sendEmail = async (callS3uploadPdf) => {
    if (!biApiData) {
      return
    }
    let payload = {
      journeyId: journeyState.journeyId,
      module: "BIEMAIL",
      applicationNumber: callS3uploadPdf ? journeyState.applicationNo : "",
      TID: biApiData?.TransactionId || "",
    }
    sendEmailBI(payload).then(res => {
      console.log(res, "emailRes")
      if (res?.status) {
        successToastr(res.message)
      } else {
        errorToastr(res.message)
      }
    })
  }


  //async function to make API call
  const getData = async () => {
    console.log("journeyState",journeyState.journeyId);
    let applicationDetailsPayload = {
      _id: journeyState.journeyId,
    }
    let applicationResult = await fetchApplicationDetails(
      applicationDetailsPayload
    )

    let payload = {
      journeyId: journeyState.journeyId,
      allRowData: true,
      productId : journeyState.productId
    }
    let journeyResult = await fetchAllJourneyData(payload)
    console.log("journeyresult",journeyResult);
    if (journeyResult?.lifeAssuredDetails?.proceedWith) {
      setProceedWithOption(journeyResult?.lifeAssuredDetails?.proceedWith)
    }
    if(journeyResult?.journeyType?.toLowerCase() === "canarapos"){
      setPayNowOrLater("later")
    }
    generateBI(payload).then(async data => {
      console.log(journeyResult, data, "vjhdvhhs")
      setAllJourneyData(journeyResult)
      setJourneyState(prev => {
        return {
          ...prev,
          premium: Math.round(JSON.parse(data?.data?.BIJson)?.[0].MODAL_PREM_TAX) || 0,
          journeyData: applicationResult.applicationData,
        }
      })
      setBiApiData(data.data);
      pdfDownload({
        applicationNumber: journeyState.applicationNo,
        TID: data.data.TransactionId || "",
      })
      .then(pdfResult => {
        setPdfData(pdfResult.data.Base64Pdf);
      })
      .catch(error => {
        console.error("Error while downloading PDF:", error);
      });
      
      getTOFpaymentReceipt(journeyState.applicationNo)
      .then(res => {
        const receipts = res.data || [];
        const validReceipts = receipts.filter(receipt => lookup.validReceiptStatus[0].hasOwnProperty(receipt.receiptStatus));
        let sum = 0;
        validReceipts.forEach(receipt => {
          sum += parseInt(receipt.amount);
        });
        if (sum >= (Math.round(JSON.parse(data.data.BIJson)?.[0].MODAL_PREM_TAX))) {
          setSkipPayment(true);
        }
        setJourneyState(prev => ({
          ...prev,
          receipts: validReceipts 
        }));
      })
      .catch(err => console.info(err));

    })
    .catch(err => {
      console.log("error in save application of save application and call BI function")
    })
  }

  const handleEnterPayoutOption = (event, value) => {
    console.log(event.key);
    if (event.key == 'Enter') {
      handlePayOption({ target: { value: value } })
    }

  }

  //Use Effects
  useEffect(async () => {
    console.log("getdata callaed");
    await getData();
    console.log("bidattttaaaa",biApiData);
  }, [])

  useEffect(() => {
    if (!journeyState?.journeyIdFromStrapi) return;
    getConfigurationsByType({ type: "gst-config" })
      .then(res => {
        const allRates = res?.data?.[0]?.config?.planWiseGSTRates || {};
        const journeyId = journeyState.journeyIdFromStrapi;
        // pick GST rates for this journey
        const journeyRates = allRates[journeyId] || null;
        setGstRate(journeyRates);
      })
      .catch(err => {
        console.error("Failed to fetch GST config", err);
      });
  }, [journeyState?.journeyIdFromStrapi]);

  // useEffect(() => {
  //   storePdfData()
  // }, [biApiData])

  //Page Functions
  const handlePayOption = ({ target }) => {
    console.log(target.value, "value in BI");
    if (target.value === "now") {
      setPayNowOrLater("now")
      setIsPayBasba(false)
    } else if (target.value === "later") {
      setPayNowOrLater("later")
      setIsPayBasba(false)
    } else if (target.value === "basba") {
      setIsPayBasba(true)
    }
  }

  const handlePrevious = () => {

    try {
      const payload = {
        journeyId: journeyState.journeyId, 
        buttonClicked:  "Previous", 
      };
      updateUserTrackerDetails(payload)
        .then((response) => {
          if (response?.status) {
            console.log("UserTracker updated successfully:", response.message);
          } else {
            console.error("Error in updating UserTracker:", response?.message);
          }
        })
        .catch((error) => {
          console.error("Error in updateUserTrackerDetails API call:", error);
        })
    } catch (error) {
      console.error("Error in handlePrevious:", error);
    }

    if (proceedWithOption === "manually") {
      props.setCurrentSectionIndex(prev => prev - 1) // this moves to previous section on same page
      setJourneyState(prev => {
        return {
          ...prev,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
        }
      })
    }
  }

  // code of tab enter
  const handleEnterPrevious = (event) => {
    if (event?.key == 'Enter') {
      handlePrevious();
    }
  }
  // code of tab enter
  const handleEnterDownload = (event) => {
    if (event?.key == 'Enter') {
      downloadPdf();
    }
  }
  // code of tab enter
  const handleEnterPrint = (event) => {
    if (event?.key == 'Enter') {
      printPdf();
    }
  }
  // code of tab enter
  const handleEnterEmail = (event) => {
    if (event?.key == 'Enter') {
      sendEmail(true);
    }
  }
  // code of tab enter
  const handleEnterRecalculate = (event) => {
    if (event?.key == 'Enter') {
      handleReCalculate();
    }
  }

  const handleProceedClick = (ev) => {
    ev.preventDefault()
    if (!isChecked) return
    if (skipPayment) {
      handleProceedSkipPayment(ev)
    } else {
      handleProceed(ev)
    }
  }

  const handleProceed = async ev => {
    ev.preventDefault()
    if (!isChecked) {
      return;
    }
    console.log("tessttttttxxxxxxxxxxx",props);

    // downloadLinkOfPdf(pdfData);
    sendEmail(true);
    const ageBI=calculateAge(allJourneyData?.lifeAssuredDetails?.dob)
      let temp = journeyState.journeySteps
      setJourneyState(prev => {
        return {
          ...prev,
          journeySteps: temp,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          paymentStep: "L",
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
          
        }
      })
    console.log("journeystateee222222222222222e",journeyState);
    setSectionState(prev => {
      // making section data empty to load new sectionData
      return {
        ...prev,
        sectionId: null,
        sectionFirstPass: null,
        sectionData: {},
      }
    })
    let sendPayload = {
      applicationData: journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        lastPageCode: props.pageId,
        paymentStep: payNowOrLater === "now" ? "N" : "L",
        isBasbaAttempted: isPayBasba ? "Y" : "N",
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
        planOption: journeyState.planOption,
        canaraPosCaseType: allJourneyData?.journeyType?.toLowerCase() === "canarapos" ? "sendCaseToCustomer" : null,
        ageAtBI:ageBI
        },
        posDashboardListingData:{
          canaraPosCaseType: "sendCaseToCustomer"
        }
      // base64Data: pdfData,
    }
    saveApplication(sendPayload).then(res => {
      console.log(res, "application response")
      props.setCurrentPageIndex(prev => prev + 1)
      setErrorState({})
      setErrorState({})
      setErrorState({})
      setErrorState({})
      props.setCurrentSectionIndex(0) 
      setSectionState(prev => {
        // making section data empty to load new sectionData
        return {
          ...prev,
          sectionId: null,
          sectionFirstPass: null,
          sectionData: {},
        }
      })
    }).catch(err => {
      console.log(err, "err in saveApplication benefit-illustration")
    })
  }

  const handleProceedSkipPayment = (e) => {
    e.preventDefault();
    const temp = journeyState.journeySteps;
    let makePaymentPageIndex = temp.pages.findIndex(page => page.pageId === "makePayment");
    temp.pages[makePaymentPageIndex].sections = temp.pages[makePaymentPageIndex].sections.filter(section => section.sectionId === "eNach-physicalMandate")//show only e-nach section if skip payment
    setJourneyState(prev => {
      return {
        ...prev,
        journeySteps: temp
      }
    });
  
    let sendPayload = {
      applicationData: journeyState.journeyData,
      skipPayment:'Y',
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex + 1,
        lastSection: 0,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        premium: Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX) || 0,
        lastPageCode: props.pageId,
        paymentStep: "N",
        isBasbaAttempted: isPayBasba ? "Y" : "N",
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        planOption: journeyState.planOption,
        canaraPosCaseType: allJourneyData?.journeyType?.toLowerCase() === "canarapos" ? "sendCaseToCustomer" : null
      },
      // base64Data: pdfData,
    }
  
    saveApplication(sendPayload).then(async res => {
      console.log(res, "application response");
      props.setCurrentPageIndex(prev => prev + 1);
      setErrorState({});
      props.setCurrentSectionIndex(0); // this moves to first section of next page
  
      // Save transaction details if skipPayment is true
      if (skipPayment) {
        const validReceipts = journeyState.receipts || [];
        const transactions = validReceipts.map(receipt => transformReceiptToTransaction(receipt, journeyState));
  
        const transactionPayload = {
          journeyId: journeyState.journeyId,
          applicationNumber: journeyState.applicationNo,
          status: 'Success',
          skipPayment: 'Y',
          transactions: transactions
        };
  
        let saveResp = await saveTransactionDetails(transactionPayload);
        console.log(saveResp, "saveTransactionDetails");
      }
      

    }).catch(err => {
      console.log(err, "err in saveApplication benefit-illustration");
    });
  }

  const handleReCalculate = () => {
      props.setCurrentPageIndex(0)
      props.setCurrentSectionIndex(0)
      const tempPage = journeyState.journeyData[0]

      // user activity
      try {
        const payload = {
          journeyId: journeyState?.journeyId, 
          buttonClicked: "ReCalculate", 
        };
         updateUserTrackerDetails(payload)
          .then((response) => {
            if (response?.status) {
              console.log("UserTracker updated successfully:", response.message);
            } else {
              console.error("Error in updating UserTracker:", response?.message);
            }
           })
          .catch((error) => {
            console.error("Error in updateUserTrackerDetails API call:", error);
          })
      } catch (error) {
        console.error("Error in handleReCalculate:", error);
      }

      setPageState(prev => {
        return {
          ...prev,
          pageId: tempPage.pageId,
          pageData: tempPage.pageData,
        }
      })
      const tempState = journeyState.journeyData[0].pageData[0]
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: tempState.sectionId,
          sectionData: tempState.sectionData,
        }
      })
  }

  const handleSendLinkToSales = (ev) => {
    ev.preventDefault()
    if (!isChecked) {
      return;
    }
    sendEmail(true);
    console.log("tesstttttt",journeyState.journeySteps.pages);
    let temp = journeyState.journeySteps

    temp.pages = temp.pages.filter(page => page.pageId !== "PageFlexiEdgeFillProposalForm" && page.pageId !== "makePayment" && page.pageId !== "PageFlexiEdgeUploadDocuments")
    temp.pages.push(...lookup.sendLinktosales)
    if(allJourneyData?.productDetails?.premiumFrequency === "SG"){
      temp.pages = temp.pages.filter(page => page.pageId !== "makePayment")
    }
    console.log(temp.pages)

    setJourneyState(prev => {
      return {
        ...prev,
        journeySteps: temp,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
        lastPageCode: props.pageId,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        paymentStep: "L",
        journeyCode: findCurrentJourneyCode(
          props.pageId,
          props.sections[props.currentSectionIndex].sectionId
        ),
        canaraPosCaseType: "sendLinktosales"
      }
    })
  console.log("journeystateeee",journeyState);
  setSectionState(prev => {
    // making section data empty to load new sectionData
    return {
      ...prev,
      sectionId: null,
      sectionFirstPass: null,
      sectionData: {},
    }
  })
  // let optInPayload = {
  //   "mobileNo": allJourneyData.salesAgentDetails.mobileNo
  // }
  // let whatsAppOptres = whatsAppOptin(optInPayload)
  let sendPayload = {
    applicationData: journeyState.journeyData,
    journeyData: {
      _id: journeyState.journeyId,
      lastPage: props.currentPageIndex,
      lastSection: props.currentSectionIndex,
      applicationNo: journeyState.applicationNo,
      illustrationNumber: journeyState.illustrationNumber,
      proposalEntryId: journeyState.proposalEntryId,
      lastPageCode: props.pageId,
      paymentStep: payNowOrLater === "now" ? "N" : "L",
      lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
      premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
      planOption: journeyState.planOption,
      canaraPosCaseType: "sendLinktosales"
    },
    posDashboardListingData:{
      canaraPosCaseType: "sendLinktosales"
    }
  }
  saveApplication(sendPayload).then(res => {
    console.log(res, "application response")
    successToastr('Application will be visible on sales Dashboard after SCR Declaration')
    props.setCurrentPageIndex(prev => prev + 1)
      setErrorState({})
      setErrorState({})
      setErrorState({})
      setErrorState({})
      props.setCurrentSectionIndex(0) 
      setSectionState(prev => {
        // making section data empty to load new sectionData
        return {
          ...prev,
          sectionId: null,
          sectionFirstPass: null,
          sectionData: {},
        }
      })
  }).catch(err => {
    console.log(err, "err in saveApplication benefit-illustration")
  })
  }


  let PlanOption= allJourneyData?.productDetails?.planOption
  
  let personalDetails = [
    {
      q1: "Name of the Life Assured:",
      ans1: wordCapital(allJourneyData?.lifeAssuredDetails?.fullName) || "NA",
      q2: "Age & Gender:",
      ans2: `${getAge(allJourneyData?.lifeAssuredDetails?.dob) || "NA"} / ${getValueFromLookup("gender",allJourneyData?.lifeAssuredDetails?.gender) || "NA"}`,
    },
    {
      q1: "Premium Payment Term",
      ans1: allJourneyData?.productDetails?.premiumPaymentTerm || "NA",
      q2: "Policy Term",
      ans2: allJourneyData?.productDetails?.policyTerm || "NA",
    },
    {
      q1: "Amount of Instalment Premium	",
      ans1: `Rs.${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM)) : "NA"}`,
      q2: "Mode of Payment of Premium",
      ans2: `${lineCapital(getValueFromLookup(
        "guaranteedFuturePaymentFrequency",
        allJourneyData?.productDetails?.premiumFrequency
      ) ?? '') || "NA"}`,
    },
    {
      q1: "Payor Premium Protection Cover",
      ans1: "No",
      q2: "Staff",
      ans2: allJourneyData?.lifeAssuredDetails?.employmentDetails?.staff == "Y" ? "Yes" : "No",
    },
    {
        q1: "Corporate Customer",
        ans1: "No",
        q2: "",
        ans2: "",
      },
  ]
  let planDetails = [
    {
      q1: "Name of the product:",
      ans1: "Canara HSBC Life Insurance iSelect Guaranteed Future",
      q2: "Tagline",
      ans2: "A Non-Linked Non-Participating Individual Savings Life Insurance Plan",
    },
    {
      q1: "Unique Identification No:",
      ans1: "136N081V04 ",
      q2: "GST Rate (Year 1)",
      ans2: (gstRate?.gstRateYear1 || "0") + "%"
    },
    {
      q1: "GST Rate (Year 2 onwards)",
      ans1: (gstRate?.gstRateYear2 || "0") + "%",
      q2: "",
      ans2:"",
    },
    // {
    //   q1: "Annuity Installment Frequency",
    //   ans1: "Yearly",
    //   q2: "Deferment Period",
    //   ans2: "NA",
    // },
    // {
    //   q1: "Annuity Commencement Date",
    //   ans1: "NA",
    //   q2: "Maturity Benefit",
    //   ans2: "Yes",
    // },
    // {
    //   q1: "Loan",
    //   ans1: "₹10,05,460",
    //   q2: "",
    //   ans2: "",
    // },
  ]
  let policyDetails = [
    {
      q1: "Policy Option",
      ans1: `${biApiData ? (JSON.parse(biApiData.BIJson)?.[0].PLAN_OPTION_DISP) : "NA"}`,
      q2: "Sum Assured on Death (at inception of the policy )",
      ans2: `${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].SA)) : "NA"}`,
    },
  ]
  let benefitDetails = [
    {
      q1: "Guaranteed Sum Assured onMaturity",
      ans1: `${biApiData ? JSON.parse(biApiData.BIJson)?.[0].GUARANTEED_SAM ?? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].GUARANTEED_SAM)) : "NA"}`,
      // ans1: `${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].GUARANTEED_SAM)) : "NA"}`,
      q2: "Total Accrued Additions till Maturity",
      ans2: `${biApiData ? JSON.parse(biApiData.BIJson)?.[0].TOTAL_GURAN_ADD ?? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].TOTAL_GURAN_ADD)) : "NA"}`,
      // ans2: `${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].TOTAL_GURAN_ADD)) : "NA"}`,
    },
    {
        q1: "High Premium Addition",
        ans1: `${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].HIGH_PREM_ADD)) : "NA"}`,
        q2: "",
        ans2: "",
      },
  ]
  let premiumSummary=[]
  
  let premiumSummary1 = [
    {
        title:"Instalment Premium without GST",
        basePlan:`${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[1].MODAL_PREM)) : "NA"}`,
        staffDiscount:`${biApiData ? JSON.parse(biApiData.BIJson)?.[0].STAFF_DISCOUNT1 ?? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].STAFF_DISCOUNT1)) : "NA"}`,
        corporateDiscount: `${biApiData ? JSON.parse(biApiData.BIJson)?.[0].CORPORATE_DISCOUNT1 ?? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].CORPORATE_DISCOUNT1)) : "NA"}`,
        Rider:"0",
        totalInstalmentPremium:`${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].TOTAL_INSTALMENT_PREM1)) : "NA"}`,
    },
    {
        title:"Instalment Premium in First Year with GST",
        basePlan: `${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].BASE_PREMIUM)) : "NA"}`,
        staffDiscount: `${biApiData ? JSON.parse(biApiData.BIJson)?.[0].STAFF_TAX_FIRST ?? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].STAFF_TAX_FIRST)) : "NA"}`,
        corporateDiscount: `${biApiData ? JSON.parse(biApiData.BIJson)?.[0].CORP_TAX_FIRST ?? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].CORP_TAX_FIRST)) : "NA"}`,
        Rider:"0",
        totalInstalmentPremium: `${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].TOTAL_INSTALMENT_PREM_TAX1)) : "NA"}`,
    },
    {
        title:"Instalment Premium 2nd year onwards with GST",
        basePlan:`${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[1].MODAL_PREM_TAX)) : "NA"}`,
        staffDiscount:"0",
        corporateDiscount:"0",
        Rider:"0",
        totalInstalmentPremium:`${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[1].MODAL_PREM_TAX)) : "NA"}`,
    },
  ]
  let premiumSummary2 = [
    {
      title:"Single Premium without GST",
      basePlan:`${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_EXCL_STAFF)) : "NA"}`,
      staffDiscount:`${biApiData ? JSON.parse(biApiData.BIJson)?.[0].STAFF_DISCOUNT1 ?? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].STAFF_DISCOUNT1)) : "NA"}`,
      corporateDiscount: `${biApiData ? JSON.parse(biApiData.BIJson)?.[0].CORPORATE_DISCOUNT1 ?? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].CORPORATE_DISCOUNT1)) : "NA"}`,
      Rider:"0",
      totalInstalmentPremium:`${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].TOTAL_INSTALMENT_PREM1)) : "NA"}`,
  },
  {
      title:"Single Premium with GST",
      basePlan: `${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].BASE_PREMIUM)) : "NA"}`,
      staffDiscount: `${biApiData ? JSON.parse(biApiData.BIJson)?.[0].STAFF_TAX_FIRST ?? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].STAFF_TAX_FIRST)) : "NA"}`,
      corporateDiscount: `${biApiData ? JSON.parse(biApiData.BIJson)?.[0].CORP_TAX_FIRST ?? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].CORP_TAX_FIRST)) : "NA"}`,
      Rider:"0",
      totalInstalmentPremium: `${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].TOTAL_INSTALMENT_PREM_TAX1)) : "NA"}`,
  },
  ]
  if(PlanOption==="IG3TR5" || PlanOption==="IG3TR6"){
   premiumSummary=premiumSummary2
  }else{
   premiumSummary=premiumSummary1
  }

  return (
    <>
      <style>
        {`

          .option-buit-design-new-new-design::after{
            height: 2rem
          }
          .shadow-box-card{
            background-color: #fff;
            box-shadow: 0px 0px 10px #ccc;
            border-radius: 10px;
            padding: 0px 0px;
            float: left;
            width: 100%;
            margin-bottom: 30px;
            height: 172px;
          }
          .option-buit-design-new-structure-sec1 .checkmark, .option-buit-design-new-structure-sec2 .checkmark, .option-buit-design-new-structure-sec3 .checkmark, .option-buit-design-new-structure-sec4 .checkmark {
            background-color: #ededed;
            left: 0px;
            top: 0px;
          }
          radio-line{
            width: 100%;
            height: 100%
          }
          .customradio{
            padding: 22px 0px
          }
          .customradio .checkmark {
            top: 22px !important;
          }
          .by-pay{
            bottom: 8px
          }
          resent-bi-center{
            position: relative;
          }
          .eky-resend {
            margin: auto;
            right: 25px;
            position: relative;
            left: 4px
          }
          .custom-otp{
            margin: auto
          }
          .table-design .table-bg .border-right td:nth-child(2){
            border-right:1px solid;
          }
          .table-design .table-bg .border-right-fund td:nth-child(3){
            border-right:1px solid;
          }
         
        `}
      </style>
      {allJourneyData && biApiData && (<div className="container">
        {/*left-side*/}
        <form
          id="declaration-form"
          name="declaration-form"
          action
          method="post"
          autoComplete="off"
          noValidate="novalidate"
        >
          <div className="iselect-padding mt-20">
            <div className="iselect-box-design mb">
              <div className="heading-design">
                <div className="iselect-padding left-side-head">
                  <h1 className="iselect-heading">Benefit Illustration</h1>
                  <span className="subhead">
                    Canara HSBC Life Insurance iSelect Guaranteed Future Plan &nbsp; | &nbsp; UIN:
                    136N081V04
                  </span>
                </div>
                <div className="app-quatation mt hidden-desktop-screen">
                  <div className="application-design-number">
                    Application Number: {journeyState.applicationNo}
                  </div>
                </div>
              </div>
              <div className="bi-summary">
                <div className="auther-description mt-20">
                  <h3>
                    Dear{" "}
                    <b>
                      {" "}
                      <strong> {allJourneyData?.journeyType == "CanaraPos" ?
                      <b>
                        { allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.title === "MR" ? 'Mr. ' :  allJourneyData?.proposerDetails?.title === "MS" ?  'Ms. ' : allJourneyData?.proposerDetails?.title === "MRS" ?  'Mrs. ' : ""
                          : (allJourneyData?.lifeAssuredDetails?.title === "MR" ? 'Mr. ' :  allJourneyData?.lifeAssuredDetails?.title === "MS" ?  'Ms. ' : allJourneyData?.lifeAssuredDetails?.title === "MRS" ?  'Mrs. ': ``)
                        }
                        {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      :
                      <b>
                        { allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.gender.toUpperCase() == "M" || allJourneyData?.proposerDetails?.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `
                          : (allJourneyData?.lifeAssuredDetails?.gender.toUpperCase() == "M" || allJourneyData?.lifeAssuredDetails?.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `)
                        }
                        {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      }
                      </strong>
                    </b>{" "}
                  </h3>
                  <p className="benefit-title">
                  Thank you for showing interest in our Canara HSBC Life Insurance iSelect Guaranteed Future Plan. Based on the details provided by you, and reproduced below, the illustration customised to your requirements is appended.
                  </p>
                  <p className="benefit-title">
                  Please note that this illustration is indicative and the actual values may vary depending on performance of the participating fund managed by the Company.
                  </p>
                  
                </div>
              </div>
              <div className="Bi-design-structure-table mt-50 iselect-mg-bottom">
                <div className="col-md-12">
                  <div className="table-responsive table-design laesf">
                    <h2 className="headline-table headline-table headline-table headline-table1">
                    Personal Details of Life to be Assured
                    </h2>
                    <div className="table-bg">
                    <table className="table border-right">
                    <tbody>
                      {personalDetails.map((elem, index) => {
                        return (
                          <tr
                            className={`table-color${
                              index % 2 == 0 ? "-grey" : ""
                            }`}
                          >
                            <td width="33%">{elem.q1}</td>
                            <td
                              width="17%"
                              align="right"
                              className="rd-tatav"
                            >
                              {elem.ans1}
                            </td>
                            <td width="26%" align="left">
                              {elem.q2}
                            </td>
                            <td width="24%" align="right">
                              {elem.ans2}
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                    </div>
                  </div>
                </div>
                <div className="clearfix" />
                <div className="col-md-12">
                  <div className="table-responsive table-design laesf">
                    <h2 className="headline-table headline-table headline-table1">Plan Details</h2>
                    <div className="table-bg">
                      <table className="table border-right">
                        <tbody>
                          {planDetails.map((elem, index) => {
                            return (
                              <tr
                                className={`table-color${
                                  index % 2 == 0 ? "-grey" : ""
                                }`}
                              >
                                <td width="20%">{elem.q1}</td>
                                <td
                                  width="30%"
                                  align="right"
                                  className="rd-tatav"
                                >
                                  {elem.ans1}
                                </td>
                                <td width="15%" align="left">
                                  {elem.q2}
                                </td>
                                <td width="35%" align="right">
                                  {elem.ans2}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="clearfix" />
                <div className="col-md-12">
                  <div className="table-responsive table-design laesf">
                  <h2 className="headline-table headline-table headline-table headline-table1">
                  Policy Details
                    </h2>
                    <div className="table-bg" style={{border:"none"}}>
                    <table className="table border-right">
                    <tbody>
                      {policyDetails.map((elem, index) => {
                        return (
                          <tr
                            className={`table-color${
                              index % 2 == 0 ? "-grey" : ""
                            }`}
                          >
                            <td width="33%">{elem.q1}</td>
                            <td
                              width="17%"
                              align="right"
                              className="rd-tatav"
                            >
                              {elem.ans1}
                            </td>
                            <td width="26%" align="left">
                              {elem.q2}
                            </td>
                            <td width="24%" align="right">
                              {elem.ans2}
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                    </div>
                  </div>
                </div>
                <div className="clearfix" />
                <div className="col-md-12">
                  <div className="table-responsive table-design laesf">
                    <h2 className="headline-table headline-table headline-table1">
                    Benefit Details
                    </h2>
                    <div className="table-bg">
                      <table className="table border-right">
                        <tbody>
                          {benefitDetails.map((elem, index) => {
                            return (
                              <tr
                                className={`table-color${
                                  index % 2 == 0 ? "-grey" : ""
                                }`}
                              >
                                <td width="33%">{elem.q1}</td>
                                <td
                                  width="17%"
                                  align="right"
                                  className="rd-tatav"
                                >
                                  {elem.ans1}
                                </td>
                                <td width="26%" align="left">
                                  {elem.q2}
                                </td>
                                <td width="24%" align="right">
                                  {elem.ans2}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="clearfix" />
                <div className="col-md-12">
                  <div className="table-responsive table-design laesf">
                    <h2 className="headline-table headline-table headline-table1">
                    Premium Summary
                    </h2>
                    <div className="table-bg">
                      <table className="table">
                        <tbody>
                        <tr style={{fontWeight:"bold"}}>
                        <td></td>
                        <td>Base Plan Premium Without Discount</td>
                        <td>Staff Discount</td>
                        <td>Corporate Discount</td>
                        <td>Rider</td>
                        <td>Total Instalment Premium</td>
                        </tr>
                          {premiumSummary.map((elem, index) => {
                            return (
                              <tr
                                className={`table-color${
                                  index % 2 == 0 ? "-grey" : ""
                                }`}
                              >
                              <td>{elem.title}</td>
                              <td align="center">{elem.basePlan}</td>
                              <td align="center">{elem.staffDiscount}</td>
                              <td align="center">{elem.corporateDiscount}</td>
                              <td align="center">{elem.Rider}</td>
                              <td align="center">{elem.totalInstalmentPremium}</td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              <div className="clearfix" />
              <div className="transactionDetailsWrap">
                <div className="detailContentWrap">
                  <div className="row">
                    <div className="buttonWrap">
                      <div
                        className="button submit-btn"
                        aria-hidden="true"
                        style={{ cursor: "pointer" }}
                        tabIndex="0"
                        onKeyPress={(e) => handleEnterDownload(e)}
                        onClick={downloadPdf}
                      >
                        <a> Download</a>
                      </div>
                      <div
                        className="button submit-btn"
                        aria-hidden="true"
                        style={{ cursor: "pointer" }}
                        onKeyPress={(e) => handleEnterPrint(e)}
                        onClick={printPdf}
                      >
                        <a> Print</a>
                      </div>
                      <div
                        className="button submit-btn"
                        aria-hidden="true"
                        style={{ cursor: "pointer" }}
                        tabIndex="0"
                        onKeyPress={(e) => handleEnterEmail(e)}
                        onClick={() => {sendEmail(true)}}
                      >
                        <a> Email</a>
                      </div>
                      <div
                        className="button submit-btn"
                        aria-hidden="true"
                        style={{
                          cursor: "default",
                        }}
                        tabIndex="0"
                        onKeyPress={(e) => handleEnterRecalculate(e)}
                        onClick={handleReCalculate}
                      >
                        <a>Re-Calculate</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              <div className="option-buit-design-new-structure Bi-page-pay-structure mt-30">
                <div className="col-md-12">
                  <div className="option-buit-design-new-structure-box">
                      {skipPayment && <p style={{
                        textAlign : "center",
                        fontSize : "18px",
                        marginTop : "30px"

                      }}>Premium of Rs {`${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX)) : "NA"}`} is adjusted against transfer of funds from old application</p>} 
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              <div className="iselect-mg-bottom mt-50 medical-btn hidden-desktop-screen">
                <div className="col-md-12">
                  <div className="but-center text-center">
                  {
                    allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? 
                    (allJourneyData?.proposerDetails?.kycVerified || allJourneyData?.proposerDetails?.ckycVerified || allJourneyData?.proposerDetails?.matchTypeDedupe) &&
                    <div
                        className="submit-btn cen"
                        >
                        {" "}
                        <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                        </div>
                    :
                      (allJourneyData?.lifeAssuredDetails?.kycVerified || allJourneyData?.lifeAssuredDetails?.ckycVerified || allJourneyData?.lifeAssuredDetails?.matchTypeDedupe) &&
                      <div
                          className="submit-btn cen"
                          >
                          {" "}
                          <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                          </div>
                    }
                    <input
                      className="previous-btn cen text-uppercase ls2"
                      aria-hidden="true"
                      style={{
                        color: "white",
                        padding: "14px 40px",
                        border: "none",
                      }}
                      type="submit"
                      value="PROCEED"
                      onClick={handleProceedClick}
                    />
                    {allJourneyData?.journeyType === "CanaraPos" &&
                      <span>
                    <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Link to Sales"  onClick={handleSendLinkToSales} />
                    {/* <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Case to Sales"  onClick={handleSendLinkToSales} /> */}
                      </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        {/*left-side*/}

        <div className="iselect-mg-bottom">
          <div className="col-md-12 pl-pr">
            <div className="discloser iselect-box-design">
              <h2>Important Notes:</h2>
              <ul>
                <li>Maturity Benefit is the benefit payable on survival of Life Assured till maturity, which is sum of Guaranteed Sum Assured on Maturity, accrued Guaranteed Additions, if any, and High Premium Addition, if any. </li>
                <li>Death Benefit payable in case of death of the Life Assured - Sum Assured on Death plus accrued Guaranteed Additions, if any plus High Premium Addition, if any. No other benefit will be payable and policy will terminate on payment of death benefit. </li>
                </ul>
                <ul>
                <li style={{listStyleType:"none"}}>Where Payor Premium Protection Cover has been chosen and Life Assured and Policyholder are the same, on death of the Life Assured, Sum Assured on Death will be paid and all future premiums will be waived off and the Policy shall continue till Maturity with all future benefits accruing as if the Policy was in-force. </li>
                <li style={{listStyleType:"none"}}>Where Payor Premium Protection Cover has been chosen and Life Assured and Policyholder are different, on death of the Policyholder, all future premiums will be waived off and the Policy shall continue till Maturity with all future benefits accruing as if the Policy was in-force. Where, Sum Assured on Death is defined as higher of </li>
                </ul>
                
                <ul>
                  <li style={{listStyleType:"none"}}>a)Sum Assured i.e. 11 times the Annualized Premium </li>
                  <li style={{listStyleType:"none"}}>b)105% of the Total Premiums Paid.</li>
                </ul>
                <ol start="3" style={{padding: "1rem", color:"#333"}}>
                  <li>Installment premium mentioned is inclusive of loadings for modal premiums and underwriting extra premium, if any. </li>
                  <li style={{marginTop:"10px"}}>Total Premiums Paid means total of all the premiums received, excluding rider premiums, underwriting extra premiums and taxes. </li>
                  <li style={{marginTop:"10px"}}>A Policy shall acquire lapse status if the Policyholder fails to pay due premium within the grace period in the first 2 consecutive Policy years. In such case your Policy will lapse at the expiry of the grace period and the insurance cover will cease immediately. No benefit shall be payable upon death or upon your request for termination of the Policy or on the expiry of the revival period. </li>
                </ol>
               <h2>Other points to note: </h2>
               <ul>
                <li>This is a traditional plan intended for long term savings and benefits. It is strongly advised that the Policy should be continued throughout the defined Policy term to realise the full benefits. If premiums are discontinued after payment of at least first 2 consecutive Policy years’ premiums then the Policy will acquire a Paid-up value. You will receive this Paid-up value on death or on maturity, provided you have not surrendered or revived the Policy.</li>
                <li>Your Policy will acquire a guaranteed surrender value (GSV) after payment of at least first 2 consecutive Policy years’ premiums. However, the Company may offer a special surrender value (SSV), and higher of GSV or SSV will be paid on surrender. The Illustration shows both the GSV as well as the current SSV payable on surrender of the Policy. SSV scales may be revised in the future by the Company with the prior approval of the Authority. </li>
                <li>Premiums payable and benefits receivable under this plan may be eligible for tax benefits as per the prevailing tax laws subject to amendments from time to time. </li>
                <li>The illustrated premium is for a healthy individual with standard premium rates. Your application will be assessed as per Board approved underwriting Policy of the Company. Basis underwriting, it may result in extra premium to be paid, which shall be borne by you.</li>
                <li>The illustration takes into account currently applicable Goods and Services Tax & applicable cess (es)/other levy, if any. However, the applicable taxes may change from time to time and total premium payable will change accordingly. </li>
                <li>For more details on product features and terms and conditions please read sales brochure and sample Policy contract carefully before concluding a sale. </li>
                <li>Insurance is the subject matter of solicitation Disclosures: There is no commission payable if the policy is sourced through Direct Sales or Online.</li>

               </ul>
               <h2>Disclosures: </h2>
               <p>There is no commission payable if the policy is sourced through Direct Sales or Online.</p>
               <p>Trade Logo of Canara HSBC Life Insurance Company Limited (formerly known as Canara HSBC Oriental Bank of Commerce Life Insurance Company Ltd) hereinafter referred to as "Insurer" is used under license with Canara Bank and HSBC Group Management Services Limited. The Insurance products are offered and underwritten by Insurer <strong>(IRDAI Regn. No. 136)</strong>  having its head office at 139 P, Sector-44, Gurugram 122003, Haryana. For more details on risk factors, terms and conditions please read the sales brochure carefully before concluding a sale. Corporate Identity No.: U66010DL2007PLC248825. Website: www.canarahsbclife.com. Call:1800-103-0003/1800-180-0003/1800-891-0003. Give a missed call to: 0124-6156600. SMS: 9779030003. Email: {getSourceFromChannel(journeyState.channel) === "U" ? "onlineterm@canarahsbclife.in" : "customerservice@canarahsbclife.in"}</p>
            </div>
          </div>
        </div>
        {/* <!--mobile view button--> */}
        <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1 canara-pos-bi-btn">
          <div className="iselect-mg-bottom">
            <div className="col-md-12">
              <div className="but-center text-center">
              {
                    allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? 
                    (allJourneyData?.proposerDetails?.kycVerified || allJourneyData?.proposerDetails?.ckycVerified || allJourneyData?.proposerDetails?.matchTypeDedupe) &&
                    <div
                        className="submit-btn cen"
                        style={{ marginRight: "5px" }}
                        >
                        {" "}
                        <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                        </div>
                    :
                      (allJourneyData?.lifeAssuredDetails?.kycVerified || allJourneyData?.lifeAssuredDetails?.ckycVerified || allJourneyData?.lifeAssuredDetails?.matchTypeDedupe) &&
                      <div
                          className="submit-btn cen"
                          style={{ marginRight: "5px" }}
                          >
                          {" "}
                          <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                          </div>
                    }
                <div className="previous-btn cen">
                  <a>
                    {" "}
                    <button
                      type="submit"
                      aria-hidden="true"
                      value="button1"
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        color: "#fff",
                      }}
                      onClick={handleProceedClick}
                    >
                      Proceed
                    </button>{" "}
                  </a>
                </div>
                  {allJourneyData?.journeyType === "CanaraPos" &&
                  <div className="previous-btn cen send-link-to-cust">
                      <span>
                        <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Link to Sales"  onClick={handleSendLinkToSales} />
                      </span>
                  </div>
                  }
                {/* <div className="previous-btn cen send-link-to-cust">
                  {allJourneyData?.journeyType === "CanaraPos" &&
                    <span>
                      <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Case to Sales"  onClick={handleSendLinkToSales} />
                    </span>
                  }
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {/* <!--mobile view button-->  */}
        <div className="clearfix"></div>
      </div>)}

    </>
  )
}
